/*
 * 信审后台-质检工单管理 *
 * *
 * */

import { GetVerifyListReq } from "@/pbjs/xcommon/collection_pb";
import { GetVerifyTicketListParamReq } from "@/pbjs/xcommon/ticket_pb"; //获取质检工单管理筛选项参数
import { BatchUpdateUserWorkStatusReq } from "@/pbjs/external/user/user_pb"; //更新用户状态
import { collectionServiceClient } from "@/api/collectionServiceClient";
import { ticketClient } from "@/api/ticketClient";
import { userClient } from "@/api/userClient";
import { Page, timeFormat } from "@/utils/index";
import { setCommon, setPage } from "@/utils/request";
import InnerRequest from "./request";
export interface Options {
    Page: Page;
    ticketId: number; // Ticket Id
    action: string;
    orderId: number; //借款id
    isReloan: number; //首付贷 0：不选，1：复贷，2：首贷
    itemId: Array<number>, //工单类型
    verifyResult: number, //审核结果
    inspectionResult: number, // 质检结果
    createTimeRange: string, //创建时间
    assignTimeRange: string, //分配时间
    completeTimeRange: string, // 完成时间
    previtemId: number;
    appname: string;
}
export interface userOptions {
    status: number;
    userId: number;
}
export function getUpdateUserWorkStatusReq(arg: userOptions) {
    let request: any = new BatchUpdateUserWorkStatusReq();
    request.setStatus(arg.status);
    request.setUseridList(arg.userId);
    return request;
}
export const getUpdateUserWorkStatusRequest = new InnerRequest(
    userClient,
    userClient.batchUpdateUserWorkStatus
);
export function getParamReq(arg: Options) {
    let request: any = new GetVerifyTicketListParamReq();
    return request;
}
export const getParamRequest = new InnerRequest(
    ticketClient,
    ticketClient.getVerifyTicketListParam
);


export function getVerifyListReq(arg: Options) {
    let request: any = new GetVerifyListReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setTicketid(arg.ticketId);
    request.setAction(arg.action);
    request.setOrderid(arg.orderId);
    request.setCompletetimerange(arg.completeTimeRange);
    request.setIsreloan(arg.isReloan);
    request.setItemidList(arg.itemId);
    request.setCreatetimerange(arg.createTimeRange);
    request.setAssigntimerange(arg.assignTimeRange);
    request.setVerifyresult(arg.verifyResult);
    request.setInspectionresult(arg.inspectionResult);
    request.setPrevitemid(arg.previtemId)
    request.setAppname(arg.appname)
    return request;
}

export const getVerifyListRequest = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.getVerifyList
);
